//@state
export interface nationalLicenseState {
  tabs: any[];
}

export const initialState: nationalLicenseState = {
  tabs: [],
};
